import { FsPeriod, FsTypeBase } from '@types';
import { useCallback, useEffect } from 'react';
import { getFsPeriodsByFsType } from '../networking';
import { usePeriods } from './useFsTypes';

const convertPeriods = (data: FsPeriod[]) =>
  data.map(({ id, text, published, date, ...item }) => ({ ...item, id, date, text: `${text} ${!published ? '(draft)' : ''}` }));

type usePeriodDropDownControlProps = {
  type?: FsTypeBase<string>;
  query?: (type: string) => Promise<FsPeriod[]>;
  paramKey: string;
};

export const usePeriodDropDownControl = ({ type, query = getFsPeriodsByFsType(), paramKey }: usePeriodDropDownControlProps) => {
  const { periods, setPeriods, periodId, setPeriodId, period } = usePeriods(paramKey);
  useFetchPeriods(type, query, setPeriods, setPeriodId);

  return {
    periods,
    setPeriods,
    period,
    periodId,
    setPeriodId,
    isLoading: periods.length === 0 && !!type,
  };
};

function useFetchPeriods(
  type: FsTypeBase<string> | undefined,
  query: (type: string) => Promise<FsPeriod[]>,
  setPeriods: (periods: FsTypeBase<string>[]) => void,
  setPeriodId: (periodId: string) => void
) {
  const getFsPeriods = useCallback(async () => {
    setPeriods([]);
    setPeriodId('');
    if (type) {
      const data = await query(type.text);
      setPeriods(convertPeriods(data));
    }
  }, [type]);

  useEffect(() => {
    getFsPeriods();
  }, [type]);
}
